export default "<div *ngIf=\"label\" class=\"label-read-only\">{{label}}:</div>\r\n<div class=\"data-read-only\">{{value}}</div>";